import type { SanityPageBuilderMediaWithHighlightsItem, SanityPageBuilderMediaWithHighlightsSection, SanityPageBuilderSection } from "@ouster/shared";
import { MediaWithHighlightsBlockItem, MediaWithHighlightsBlockView } from "~/features/blocks/inventory/media-with-highlights";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMediaWithHighlightsSection;
  };
};
export function SanityMediaWithHighlightsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const highlights = sectionContent.highlights ?? [];
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  return <MediaWithHighlightsBlockView<SanityPageBuilderMediaWithHighlightsItem> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasCounters={sectionContent.hasCounters} hasTopDivider={sectionSettings?.hasTopDivider ?? true} highlights={highlights} media={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="1/1" /> : undefined} mode={mode} renderHighlight={(item, _index, count) => <MediaWithHighlightsBlockItem count={count} label={item.label} text={item.text} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={theme} />;
}